export function getReferralFromSubstrateInfo(substrateInfo) {
    return substrateInfo.contentDomain;
}
//# sourceMappingURL=getReferralFromSubstrateInfo.js.map